import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/JPGlogoColorLarge.jpg'


const _hoisted_1 = { class: "border-b bg-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "JohnsonInspection",
  class: "h-24 mx-auto"
}, null, -1)
const _hoisted_3 = { class: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8" }
const _hoisted_4 = { class: "py-4" }

import {
		useRoute
	} from 'vue-router'

	
	const __default__ = { name: 'MainLayout' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const route = useRoute()
	

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(route).name === 'LandingPage' ? 'bg-gray-50' : 'bg-white', 'min-h-screen'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: {name: 'LandingPage'} }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2))
}
}

})